import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './logo-banners.styl'

class LogoBanner extends React.Component {
  render(){
    return (
      <div className="logo-banners">
        { this.props.data.map(banner => {
            return (
              <div key={banner.key} className="logo-banner">
                <div className="logo-banner__avatar ">
                  { banner.logoLinkAddress &&
                    <a href={banner.logoLinkAddress} target="_blank">
                      <img className="no-margin" src={ banner.logoImg }  alt={banner.logoAlt} />
                    </a>
                  }
                  { !banner.logoLinkAddress &&
                    <img className="no-margin" src={ banner.logoImg }  alt={banner.logoAlt} />
                  }
                </div>
                <div className="logo-banner__description">
                  <p className="subcategory-text" dangerouslySetInnerHTML={{ __html: banner.description }} />
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default LogoBanner;



// WEBPACK FOOTER //
// ./src/components/logo-banners/logo-banners.js